export default "/images/vendor/flag-icon-css/flags/1x1/dj.svg?52e5fa9d44c086c8bca451cddb7af94e";